export default __webpack_public_path__ + "static/media/search.90799e40.svg";